import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../fundamentals/text-styles/constants'

const chipsVariantOptions = {
  MINIMAL: 'minimal',
  STRONG: 'strong',
  DARK: 'dark',
  ORANGE: 'orange'
}

const chipsSizeOptions = {
  MEDIUM: 'medium',
  LARGE: 'large',
  SMALL: 'small'
}

const chipsStyleOptions = {
  [chipsSizeOptions.SMALL]: {
    height: '24px',
    ...textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']],
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]
  },
  [chipsSizeOptions.MEDIUM]: {
    height: '32px',
    ...textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']],
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]
  },
  [chipsSizeOptions.LARGE]: {
    height: '40px',
    ...textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']],
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]
  }
}

const chipsImageStyleOptions = {
  [chipsSizeOptions.SMALL]: {
    width: '16px',
    height: '16px'
  },
  [chipsSizeOptions.MEDIUM]: {
    width: '24px',
    height: '24px'
  },
  [chipsSizeOptions.LARGE]: {
    width: '32px',
    height: '32px'
  }
}

const chipsComponentTypeOptions = {
  INPUT: 'input',
  CHOICE: 'choice'
}

export {
  chipsVariantOptions,
  chipsSizeOptions,
  chipsStyleOptions,
  chipsImageStyleOptions,
  chipsComponentTypeOptions
}
